import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let sceneTextEnterD: any = null,
    sceneTextLeaveD: any = null;
export default function D() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.SHP2');
    const [textEnter, setTextEnter] = useState(false);

    const [isH5, setIsH5] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterD) {
                    AniContainer.removeScene(sceneTextEnterD);
                    sceneTextEnterD = null;
                }
                if (sceneTextLeaveD) {
                    AniContainer.removeScene(sceneTextLeaveD);
                    sceneTextLeaveD = null;
                }
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterD = AniContainer.create({
                    triggerElement: '.shp2-detail-D .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                });
                //}
            };
            resizeAni();
            return () => {
                if (sceneTextEnterD) {
                    AniContainer.removeScene(sceneTextEnterD);
                    sceneTextEnterD = null;
                }
                if (sceneTextLeaveD) {
                    AniContainer.removeScene(sceneTextLeaveD);
                    sceneTextLeaveD = null;
                }
            };
        }
    }, [isH5]);

    return (
        <>
            <section className={`shp2-detail-D shp2-detail-section ${css['shp2-detail-D']}`}>
                <EfSpec />
                <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                    <h4 className="subtitle">{t('secD_subtitle')}</h4>
                    <h2 className="title">{t('secD_title')}</h2>
                    <p className="desc">
                        {t.rich('secD_desc', {
                            w: (text: string) => <span className="white">{text}</span>,
                        })}
                    </p>
                </div>
                <div className="video-box">
                    <EFPicture
                        src={'/responsive/picture/smart-home-panel-2/launch/4.jpg'}
                        srcPad={'/responsive/picture/smart-home-panel-2/launch/4_768.jpg'}
                        srcMobile={'/responsive/picture/smart-home-panel-2/launch/4_768.jpg'}
                        alt={t('secD_title')}
                    />
                </div>
                <EfSpec />
            </section>
        </>
    );
}
